import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveWorkoutLength } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import SingleSelect from '../../../components/single-select';

const phoenixSelectOptions = [
  {
    optionText: '10–20 minutes',
    optionValue: {
      min: 10,
      max: 20
    }
  },
  {
    optionText: '20–30 minutes',
    optionValue: {
      min: 20,
      max: 30
    }
  },
  {
    optionText: '30–40 minutes',
    optionValue: {
      min: 30,
      max: 40
    }
  },
  {
    optionText: '40+ minutes',
    optionValue: {
      min: 40,
      max: null
    }
  }
];

const wolfSelectOptions = [
  {
    optionText: '30 minutes or less',
    optionValue: {
      min: null,
      max: 30
    }
  },
  {
    optionText: '30 to 45 minutes',
    optionValue: {
      min: 30,
      max: 45
    }
  },
  {
    optionText: '45+ minutes',
    optionValue: {
      min: 45,
      max: null
    }
  }
];

export class PurePreferredWorkoutLength extends Component {
  constructor(props) {
    super(props);

    this.state = { workoutLength: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveWorkoutLength(this.state.workoutLength);
    } catch (e) {
      /* do nothing */
    }
  }

  getSelectOptions = () => {
    if (this.props.appName === 'wolf') {
      return wolfSelectOptions;
    }
    return phoenixSelectOptions;
  }

  onSelect = (selectOption) => {
    const selectOptions = this.getSelectOptions();
    const workoutLength = selectOption === null ? {} : selectOptions[selectOption].optionValue;
    this.setState({ workoutLength });
  }

  getActiveOption = () => {
    const selectOptions = this.getSelectOptions();
    const min = this.state.workoutLength.min;
    const max = this.state.workoutLength.max;
    return selectOptions.findIndex(({ optionValue }) => {
      if (min === optionValue.min && max === optionValue.max) {
        return true;
      }
      if (!optionValue.min && max <= optionValue.max) {
        return true;
      }
      if (!optionValue.max && min >= optionValue.min) {
        return true;
      }
      return false;
    });
  }

  render() {
    return (
      <SettingsContainer
        className="workout-length-page"
        pageTitle="What's your preferred workout length?"
        save={ this.save }
        isValid={ Boolean(this.state.workoutLength.min) || Boolean(this.state.workoutLength.max) }
      >
        <SingleSelect
          selectOptions={ this.getSelectOptions() }
          value={ this.getActiveOption() }
          onSelect={ this.onSelect }
        />
      </SettingsContainer>
    );
  }
}

PurePreferredWorkoutLength.propTypes = {
  appName: PropTypes.string,
  initialValue: PropTypes.object.isRequired,
  saveWorkoutLength: PropTypes.func.isRequired
};

export default connect(
  state => ({
    appName: state.config.appName,
    initialValue: {
      min: state.user.preferred_workout_length_min,
      max: state.user.preferred_workout_length_max
    }
  }),
  dispatch => ({
    saveWorkoutLength: workoutLength => dispatch(saveWorkoutLength(workoutLength))
  }),
  null,
  { withRef: true }
)(PurePreferredWorkoutLength);
